import { render, staticRenderFns } from "./CompanyJobsCdljnViewMore.vue?vue&type=template&id=2b1a2a5e&scoped=true"
import script from "./CompanyJobsCdljnViewMore.vue?vue&type=script&lang=js"
export * from "./CompanyJobsCdljnViewMore.vue?vue&type=script&lang=js"
import style0 from "./CompanyJobsCdljnViewMore.vue?vue&type=style&index=0&id=2b1a2a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a2a5e",
  null
  
)

export default component.exports